<template>
  <div class="news">
    <ul>
      <li
        v-for="(news, i) in newsList"
        :key="news.id"
        v-show="i < 6"
        @click="handleView(news.id)"
      >
        <div class="news">
          <span class="news-title">{{ news.title | changeShow }}</span>
          <span class="news-time">{{ news.created_at }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { articles } from '@/api/introduction/index'
import { formatLan } from '@/utils/lanFormat'
export default {
  name: 'news',
  components: {},
  props: [],
  data() {
    return {
      newsList: [],
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getArticles()
  },
  mounted() {},
  methods: {
    getArticles() {
      articles({ menu_id: 29, limit: 100 }).then((res) => {
        const { data } = res.data
        this.newsList = data
      })
    },
    handleView(id) {
      this.$router.push({ path: '/introduction', query: { id: 29, aid: id } })
    },
  },
  filters: {
    changeShow(val) {
      if (typeof val === 'object') {
        return formatLan(val)
      } else {
        return val
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.news {
  ul {
    display: flex;
    flex-flow: wrap;
    padding-left: 0;
    li {
      display: block;
      width: 50%;
      padding: 20px 30px;
      background: #ffffff;
      box-shadow: 3px 5px 6px 0px rgba(25, 59, 83, 0.2);
      border-radius: 5px;
      margin: 10px 0;
      cursor: pointer;
      border-bottom: 5px solid #fff;
      &:nth-child(odd) {
        width: calc(50% - 20px);
        margin-right: 20px;
      }
      &:hover {
        border-bottom: 5px solid #a63528;
      }
      .news {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .news-title {
          padding-right: 10px;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .news-time {
          flex-shrink: 0;
        }
      }
    }
  }
}
</style>